// import VueMoveable from './VueMoveable';
import Moveable from './Moveable.vue';

export default Moveable;
export { Moveable as VueMoveable };
export * from 'moveable';
